import { Routes } from '@angular/router';
import { arrecadacaoRoutes } from './arrecadacao/arrecadacao.routes';
import { dividaAtivaRoutes } from './dividaativa/divida-ativa.routes';

export const financeiroRoutes: Routes = [...arrecadacaoRoutes, ...dividaAtivaRoutes];

export default financeiroRoutes;
